import { render, staticRenderFns } from "./LearningOutcomeReports.vue?vue&type=template&id=0ba2261d"
import script from "./LearningOutcomeReports.vue?vue&type=script&lang=js"
export * from "./LearningOutcomeReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports